export default {
  form: {
    required: 'Please, fill out this field.',
    email: 'Invalid e-mail.',
    password:
      'Invalid password. Please make sure your password has at least 6 characters with at least 1 lowercase character, 1 uppercase character and 1 digit',
    host: 'The host needs to be a valid URL',
  },
};
